export default {
    state: {
        url: '/api/hms/clients/admissions',
        admission_id: null,
        errors: {},

        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'client', label: 'Admission'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'unit', label: 'Unit', tdClass: 'text-muted'},
                {key: 'move_in', label: 'Move In', sortable: true, tdClass: 'text-muted'},
                {key: 'move_out', label: 'Move Out', sortable: true, tdClass: 'text-muted'},
                {key: 'staying_for', label: 'Staying For', tdClass: 'text-muted'},
                {key: 'status', label: 'Status', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },

        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },

        form: {
            client_id: '',
            move_in: null,
            facility_id: '',
            unit_id: '',
            remarks: '',
        },

        discharge_form: {
            unit_id: null,
            move_out: null,
            notes: '',
        },

        transfer_form: {
            transfer_date: '',
            unit_id: '',
            notes: '',
        }
    },

    getters: {
        getAdmissionTableFields: state => state.table.fields,

        getAdmissionsMeta: state => state.meta,

        getAdmissionForm: state => state.form,

        getAdmissionErrors: state => state.errors,

        getDischargeForm: state => state.discharge_form,

        getDischargeErrors: state=> state.errors,

        getAdmissionTransferErrors: state=> state.errors,

        getTransferFrom: state => state.transfer_form

    },

    mutations: {
        setAdmissionForm: state => {
            state.form = {
                client_id: '',
                move_in: null,
                facility_id: '',
                unit_id: '',
                remarks: '',
            };

            state.errors = {};
        },

        setAdmissions: (state, payload) => {
            state.clients = payload;
        },

        resetAdmissionsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setAdmissionsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setAdmissionErrors: (state, payload) => {
            state.errors = payload;
        },

        setDischargeForm: state => {
            state.discharge_form = {
                move_out: 'null',
                remarks: ''
            };

            state.errors = {};
        },

        setTransferForm: state => {
            state.transfer_form = {
                transfer_date: '',
                unit_id: '',
                remarks: ''
            };

            state.errors = {};
        },

    },

    actions: {
        fetchAdmissions: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setAdmissions', response.data);

                        commit('setAdmissionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setAdmissionErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        deleteAdmission: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.admission_id, {data: {...payload.form}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setAdmissionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        fetchEditAdmission: ({state, commit}, admission_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + admission_id + '/edit')
                    .then(response => {
                        state.admission_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitAdmission: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setAdmissionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitAdmissionTransfer: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(`${state.url}/${payload.admission_id}/transfer`, payload.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setAdmissionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitDischarge: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(`${state.url}/${payload.admission_id}/discharge`, payload.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setAdmissionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },
    },
}
